import { getActiveRestaurantId } from "../utils/activeRestaurant";
import { useEffect, useState } from "react";
import { IRestaurantDetail } from "../models/IRestaurantDetail";
import { getRestaurantById } from "../services/restaurant";
import { ILoginInfo } from "../models/ILoginInfo";
import { decrypt } from "../utils/Util";
import AddRestaurantPage from "./AddRestaurantPage";
import EditRestaurantDeliveryAddress from "../components/EditRestaurantsDeliveryAddress";
import MyFoods from "../components/MyFoods";
import UploadRestaurantLogoModal from "../components/UploadRestaurantLogoModal";
import UploadRestaurantFeaturedImageModal from "../components/UploadRestaurantFeaturedImageModal";

type TabId = "pills-home" | "pills-profile" | "pills-adress";

const TABS: { id: TabId; label: string; icon: string }[] = [
  { id: "pills-home",    label: "Menu",              icon: "bi-grid"          },
  { id: "pills-profile", label: "Detay",             icon: "bi-pencil-square" },
  { id: "pills-adress",  label: "Siparis Adresleri", icon: "bi-geo-alt"       },
];

function RestaurantSettingsPage() {
  const [restaurantId, setRestaurantId] = useState<string>("");
  const [restaurantDetail, setRestaurantDetail] = useState<IRestaurantDetail>();
  const [activeTab, setActiveTab] = useState<TabId>("pills-home");
  const [showLogoModal, setShowLogoModal] = useState(false);
  const [showFeaturedModal, setShowFeaturedModal] = useState(false);

  useEffect(() => {
    const userJson = localStorage.getItem("user");
    if (userJson) {
      const encUser: ILoginInfo = JSON.parse(decrypt(userJson));
      if (getActiveRestaurantId()) setRestaurantId(getActiveRestaurantId());
    }
  }, []);

  useEffect(() => {
    if (restaurantId) {
      getRestaurantById(restaurantId).then((res) => {
        if (res.data) setRestaurantDetail(res.data);
      });
    }
  }, [restaurantId]);

  const refreshRestaurant = () => {
    if (restaurantId) {
      getRestaurantById(restaurantId).then((res) => {
        if (res.data) setRestaurantDetail(res.data);
      });
    }
  };

  return (
    <div className="container py-4" style={{ maxWidth: "1200px" }}>

      {/* ── Restoran özet kartı ── */}
      {restaurantDetail && (
        <div className="mb-4">
          <div
            className="p-3 rounded-3"
            style={{
              background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
              border: "1.5px solid #e9ecef",
              boxShadow: "0 4px 16px rgba(0,0,0,0.07)",
            }}
          >
            <div className="d-flex align-items-center">
              <div className="url-logo-wrap" onClick={() => setShowLogoModal(true)} title="Logoyu güncelle">
                <img
                  src={"https://mutfacik.s3.eu-central-1.amazonaws.com/" + restaurantDetail.restourantLogoPath}
                  className="url-logo-img"
                  alt={restaurantDetail.restourantName}
                />
                <div className="url-logo-edit-overlay">
                  <i className="bi bi-pencil-fill"></i>
                </div>
              </div>
              <div className="ms-3 flex-grow-1">
                <h5 className="mb-1 fw-bold" style={{ fontSize: "1.1rem" }}>
                  {restaurantDetail.restourantName}
                </h5>
                <div className="d-flex gap-2 flex-wrap mt-1 align-items-center">
                  {restaurantDetail.restourantIsEnabled ? (
                    <span
                      className="badge"
                      style={{ background: "#dcfce7", color: "#166534", fontSize: "0.72rem", borderRadius: "20px", padding: "4px 10px" }}
                    >
                      <i className="bi bi-door-open-fill me-1"></i>Acik
                    </span>
                  ) : (
                    <span
                      className="badge"
                      style={{ background: "#fee2e2", color: "#991b1b", fontSize: "0.72rem", borderRadius: "20px", padding: "4px 10px" }}
                    >
                      <i className="bi bi-door-closed-fill me-1"></i>Kapali
                    </span>
                  )}
                </div>
              </div>
            </div>

            {/* Öne çıkan görsel */}
            <div
              className="url-featured-wrap"
              onClick={() => setShowFeaturedModal(true)}
              title="Öne çıkan görseli güncelle"
            >
              {restaurantDetail.restourantFeatureadImagePath ? (
                <img
                  src={"https://mutfacik.s3.eu-central-1.amazonaws.com/" + restaurantDetail.restourantFeatureadImagePath}
                  className="url-featured-img"
                  alt="öne çıkan görsel"
                />
              ) : (
                <div className="url-featured-empty">
                  <i className="bi bi-card-image"></i>
                  <span>Öne Çıkan Görsel Ekle</span>
                </div>
              )}
              <div className="url-logo-edit-overlay">
                <i className="bi bi-pencil-fill"></i>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Sekme navigasyonu ── */}
      <div
        className="d-inline-flex gap-1 mb-4 p-1 rounded-3"
        style={{ background: "#f1f3f5" }}
      >
        {TABS.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActiveTab(tab.id)}
              style={{
                borderRadius: "10px",
                padding: "8px 18px",
                fontWeight: 600,
                fontSize: "0.88rem",
                color: isActive ? "#212529" : "#6c757d",
                background: isActive ? "#ffffff" : "transparent",
                border: isActive ? "1px solid #e0e0e0" : "1px solid transparent",
                boxShadow: isActive ? "0 1px 4px rgba(0,0,0,0.1)" : "none",
                transition: "all 0.2s",
                cursor: "pointer",
              }}
            >
              <i className={`bi ${tab.icon} me-1`}></i>{tab.label}
            </button>
          );
        })}
      </div>

      {/* ── Logo upload modal ── */}
      {restaurantDetail?.id && (
        <UploadRestaurantLogoModal
          isOpen={showLogoModal}
          onClose={() => setShowLogoModal(false)}
          onSaved={refreshRestaurant}
          restaurantId={restaurantDetail.id}
          restaurantName={restaurantDetail.restourantName}
        />
      )}

      {/* ── Featured image upload modal ── */}
      {restaurantDetail?.id && (
        <UploadRestaurantFeaturedImageModal
          isOpen={showFeaturedModal}
          onClose={() => setShowFeaturedModal(false)}
          onSaved={refreshRestaurant}
          restaurantId={restaurantDetail.id}
          restaurantName={restaurantDetail.restourantName}
        />
      )}

      {/* ── İçerik ── */}
      <div>
        {activeTab === "pills-home" && (
          <MyFoods
            selectedRestaurantId={restaurantDetail?.id}
            onSelectFood={() => {}}
          />
        )}
        {activeTab === "pills-profile" && (
          <AddRestaurantPage props={restaurantDetail} isUpdate={true} onSaved={refreshRestaurant} />
        )}
        {activeTab === "pills-adress" && (
          <EditRestaurantDeliveryAddress restaurant={restaurantDetail} />
        )}
      </div>
    </div>
  );
}

export default RestaurantSettingsPage;
